//---------------------------------------------------
//  Nom du fichier : Login.js 
//
//  Description: Component qui permet à l'utilisateur de se connecter
//
//  Auteur: Vega Laliberté et Alek Del Balso
//---------------------------------------------------

import React, { useState } from 'react';
import './Login.css';
import './btn.css';
import Background from './background';
import {callAPI} from './callAPI.js'
import { useTranslation } from "react-i18next";

function Login({setLoggedIn, setGradeType, openLogin, setImagePath,connectWebSocket}) {

  const { t } = useTranslation();
  const [wrong, setWrong] = useState(false)

  function handleSubmit(e) {
    e.preventDefault();

    setWrong(false)
    setTimeout(() => {
      const form = new FormData()
      form.append('type', 'loginUser')
      form.append('username', username)
      form.append('password', password)
  
  
      callAPI("read", form, true)
      .then((data) => {
        if(data['result'] !== "CONNECTION_ERROR"){
          setLoggedIn(true)
          setGradeType(data.grade_type)
          setImagePath(data.imagePath)
          localStorage.setItem("user_id", data.user_id)
          localStorage.setItem("role", data.role)
          connectWebSocket()
        }
        else{
          setWrong(true)
        }
      })
      .catch((error) => {
          console.error("API call failed:", error);
      });
    },200)
  }

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [visibleOrNot, setVisibleOrNot] = useState("password");

  return (
    <div>
      <Background func={() => {openLogin(false)}}>
        <div className='login'>
          <form className='formOfLogin' method='post' onSubmit={handleSubmit}>
            <h1 className='titleLogin'>{t('login_title')}</h1>
            {wrong && <div className='wrongInput'>{t('login_wrong')}</div>}
            <label className='login_container'>
              <p className='champ'>{t('username')}</p>
              <input 
                className='inputLogin'
                required 
                name="username"
                autoComplete="username"
                value={username}
                onChange={e => setUsername(e.target.value)}/>
            </label>
            <label className='login_container'>
              <p className='champ'>{t('password')}</p>
              <input 
                className='inputLogin'
                required 
                type={visibleOrNot}
                name="password"
                autoComplete="current-password"
                value={password}
                onChange={e => setPassword(e.target.value)}/>
              <span 
                className="material-symbols-outlined oeil" 
                onClick={() => {
                  if (visibleOrNot === "password") {
                    setVisibleOrNot("text");
                  } else {
                    setVisibleOrNot("password");
                  }
                }} 
                style={{ cursor: 'pointer', textTransform: 'lowercase' }}
              >
                {visibleOrNot === "password" ? "visibility" : "visibility_off"}
              </span>
            </label>
            <button className='btLogin' type="submit"></button>
          </form>
        </div>
        </Background>
    </div>
  );
}

export default Login;